import { makeAutoObservable } from 'mobx'
import { LocationStore } from './AdminPanel/Location.Store'
import { AuthStore } from './AuthStore'
import { SettingsStore } from './SettingsStore'
import { AuthUi } from './uiStore/AuthUi'
import { ModalsUi } from './uiStore/ModalsUi'
import { UserAction } from './UserAction/UserAction'

class RootStore {
  authStore: AuthStore
  authUi: AuthUi
  modalsUi: ModalsUi
  locationStore: LocationStore
  userAction: UserAction
  settingsStore: SettingsStore

  constructor() {
    makeAutoObservable(this)

    this.authStore = new AuthStore()

    this.authUi = new AuthUi()
    this.modalsUi = new ModalsUi()
    this.locationStore = new LocationStore()
    this.userAction = new UserAction()
    this.settingsStore = new SettingsStore()
  }
}

export default new RootStore()
